import clsx from "clsx";
import PropTypes from "prop-types";
import "./field-label.scss";

export const FieldLabel = ({ children, className = "", ...props }) => {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label {...props} className={clsx("ha-field-label", className)}>
      {children}
    </label>
  );
};

FieldLabel.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
